/**
 * The colorizer is used to generate colors for the text and background of the
 * category and tag badges.
 * It uses a hash function to assign buckets to each category and tag, and then
 * returns the color for that bucket.
 *
 * For a given string, the hash function will always return the same value, so
 * the colors will be consistent and distinct (enough) for each category and tag.
 */


const backgroundColors = ['#E5EDFF', '#F1E5FF', '#FFE5FC', '#E5FFFF'];

const textColors = ['#3C78FF', '#9640FC', '#FD22E4', '#0EA7A7'];


/**
 * Returns a color for the text of a category or tag badge.
 */
export function colorizeText(str: string) {
  const hash = stringToColorHash(str);
  return indexToColor(hash, textColors);
}
/**
 * Returns a color for the background of a category or tag badge.
 */
export function colorizeBackground(str: string) {
  const hash = stringToColorHash(str);
  return indexToColor(hash, backgroundColors);
}

function stringToColorHash(str: string) {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }
  return hash;
}

function indexToColor(index: number, colors: string[]) {
  return colors[Math.abs(index) % colors.length];
}
